import { ACDSessionManager } from '@nice-devone/core-sdk';
import { getConferenceParties, ConferencePartyInfo } from '../../../../services/cxone-sdk.service';
import { logCallActivity } from '../../../../services/call-log/call-log.service';
import { logger } from '../../../../utils/logger';
import { CXoneEventsSubscriptionContext, EventSubscription } from '../../subscription-context';

export function subscribeConferenceEvents(
  acdSession: ACDSessionManager,
  ctx: CXoneEventsSubscriptionContext
): EventSubscription | null {
  if (!acdSession.conferenceCallEvent) {
    return null;
  }

  return acdSession.conferenceCallEvent.subscribe(async (conferenceNo: string) => {
    if (!conferenceNo) {
      return;
    }

    ctx.setCallState((prev) => ({
      ...prev,
      isConference: true,
    }));

    try {
      const parties = await getConferenceParties();
      if (parties.length > 0) {
        const mappedParties = parties.map((party: ConferencePartyInfo) => ({
          partyId: party.partyId,
          partyType: party.partyType,
          name: party.name,
          phoneNumber: party.phoneNumber,
          isOriginalCaller: party.isOriginalCaller,
        }));

        ctx.setCallState((prev) => ({
          ...prev,
          isConference: true,
          conferenceParties: mappedParties,
        }));

        logCallActivity(
          'CALL_CONFERENCE_UPDATED',
          { parties: mappedParties },
          ctx.callStateRef.current.contactId
        );
      }
    } catch (error) {
      logger.warn('[Events] Failed to fetch conference parties:', error);
    }
  });
}
